import { getApiClient } from 'service/apiClient'

const apiClient = getApiClient(process.env.REACT_APP_MATERIALS_API_URL)

export const getAllMaterials = async () => {
  let materials = []
  let nextToken = undefined
  do {
    const { data: response } = await apiClient.get('/materials', {
      params: {
        nextToken
      }
    })
    nextToken = response.nextToken
    materials = materials.concat(response.materials)
  } while (nextToken !== undefined)

  return materials
}

export const updateMaterial = (materialNumber, data) => {
  return apiClient.patch(`/materials/${materialNumber}`, data)
}

export const saveMaterial = (data) => {
  return apiClient.post('/materials', data)
}
